import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

interface ProjectSlide {
  imgUrl: string;
  websiteUrl: string;
}

@Component({
  selector: 'visitor-mobile-projects',
  templateUrl: './mobile-projects.component.html',
  styleUrls: ['./mobile-projects.component.css']
})
export class MobileProjectsComponent implements OnInit {

  public projectConfig: SwiperConfigInterface;
  public index: number;
  public projects: ProjectSlide[];

  constructor() {
    this.projectConfig = {
      spaceBetween: 60,
      centeredSlides: true,
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
      }
    };

    this.projects = [
      {
        imgUrl: '../../../../../assets/espacioclick.svg',
        websiteUrl: '#'
      },
      {
        imgUrl: '../../../../../assets/cotalker.svg',
        websiteUrl: '#'
      },
    ];
  }

  ngOnInit(): void {
  }

}
